import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import DatasourceTabs from '~/components/DicomUpload/Datasources';
import {
    DatasourceOptions,
    datasourceModalOpenState,
    datasourceModalViewMode,
    selectedDatasourceState,
} from '~/state/atoms/viewerAtoms';
import Modal from '../../components/Modal';
import LoadedPatients from './LoadedPatients';
import ViewSwitcher from './LoadedPatients/ViewSwitcher';
import ServerPatients from './ServerPatients';

const DatasourceSection = () => (
    <Box
        pr={3}
        sx={{
            borderRight: (theme) => `1px solid ${theme.palette.divider}`,
        }}
    >
        <Typography id="modal-modal-title" variant="h6" component="h2">
            Load datasets
        </Typography>
        <Typography variant="body2" mb={1}>
            You can upload DICOM files from your device, download them from an
            Orthanc DICOM Server, or access them remotely from Azure storage.
        </Typography>
        <DatasourceTabs />
    </Box>
);

const DatasetsSection = () => {
    const selectedDatasource = useRecoilValue(selectedDatasourceState);
    const [viewMode, setViewMode] = useRecoilState(datasourceModalViewMode);

    return (
        <Box
            width="100%"
            display="flex"
            flexDirection="column"
            overflow="hidden"
        >
            <Box
                display="grid"
                gridTemplateColumns="1fr auto"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
            >
                <Box>
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                    >
                        <FormattedMessage id="patients" />
                    </Typography>
                    <Typography variant="body2" mb={1}>
                        <FormattedMessage id="patientDatasetsDescription" />
                    </Typography>
                </Box>
                {selectedDatasource !== DatasourceOptions.SERVER && (
                    <ViewSwitcher
                        viewMode={viewMode}
                        onViewModeChange={setViewMode}
                    />
                )}
            </Box>
            <Box
                height="100%"
                sx={(theme) => ({
                    overflowY: 'auto',
                    borderRadius: `${theme.shape.borderRadius}px`,
                    border: `1px solid ${theme.palette.divider}`,
                })}
            >
                {selectedDatasource === DatasourceOptions.SERVER ? (
                    <ServerPatients />
                ) : (
                    <LoadedPatients viewMode={viewMode} />
                )}
            </Box>
        </Box>
    );
};

export default function PatientDatasetModal() {
    const [open, setOpen] = useRecoilState(datasourceModalOpenState);
    const handleClose = () => setOpen(false);
    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                display="grid"
                gridTemplateColumns="260px 1fr"
                width="80vw"
                height="80vh"
                gap={3}
            >
                <DatasourceSection />
                <DatasetsSection />
            </Box>
        </Modal>
    );
}
